import { type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Text } from 'Text';

// A label + control + optional error line, used for the controls that don't carry their own label.
// The component-library `Input` has a built-in floating label, but `Select` is a bare control, so
// its call sites need this to reproduce the old form's `<label class="required">` rows.
//
// `className` is for the caller to size/position the field within its own layout; this component
// only owns its internal stacking.
export function LabeledField({
    label,
    isRequired = false,
    errorMessage,
    className,
    children,
}: {
    label: string;
    isRequired?: boolean;
    errorMessage?: string;
    className?: string;
    children: ReactNode;
}) {
    return (
        <div className={twMerge('flex flex-col gap-1', className)}>
            <Text as="div" color="black" weight="semibold" className="text-sm">
                {label}
                {isRequired ? <span className="ms-0.5 text-danger">*</span> : null}
            </Text>
            {children}
            {errorMessage ? (
                <Text as="div" color="red" className="text-xs">
                    {errorMessage}
                </Text>
            ) : null}
        </div>
    );
}
